import { render, staticRenderFns } from "./PageEditorContentNavSection.vue?vue&type=template&id=fdc3fcf0&scoped=true"
import script from "./PageEditorContentNavSection.vue?vue&type=script&lang=js"
export * from "./PageEditorContentNavSection.vue?vue&type=script&lang=js"
import style0 from "./PageEditorContentNavSection.vue?vue&type=style&index=0&id=fdc3fcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc3fcf0",
  null
  
)

export default component.exports